import * as FetchHttpClient from '@effect/platform/FetchHttpClient';
import { Fixtuur } from '@fixtuur/backpack';
import { Manifest } from '@fixtuur/manifest-client';
import { Effect, Layer } from 'effect';

export const getProductStatusEff = (
    manifestUrl: string,
    productId: string,
    tenant: Fixtuur.Tenant.TenantId,
) => {
    const manifestConfig = Layer.sync(Manifest.ManifestConfigService, () => ({
        manifestUrl: Effect.succeed(manifestUrl),
    }));

    return Manifest.ReadManifestService.pipe(
        Effect.andThen(manifest => manifest.getPublishedStatusForProduct(productId, tenant)),
        Effect.withRequestCaching(true),
        Effect.provide(
            Manifest.LiveReadManifestService.pipe(
                Layer.provide(manifestConfig),
                Layer.provide(FetchHttpClient.layer),
            ),
        ),
    );
};

export const isPublishedEff = (
    productId: string,
    tenantId: Fixtuur.Tenant.TenantId,
    solution: 'aspect' | '3dxConfiguration' | '3dxInspiration' | 'content',
) =>
    Manifest.ReadManifestService.pipe(
        Effect.andThen(manifest => manifest.getPublishedStatusForProduct(productId, tenantId)),
        Effect.withRequestCaching(true),
        Effect.andThen(publishedStatuses => publishedStatuses[solution] === 'published'),
    );

export const isPublished = (
    manifestUrl: string,
    productId: string,
    tenant: Fixtuur.Tenant.TenantId,
): Promise<boolean> => {
    const status = Effect.runPromise(
        isPublishedEff(productId, tenant, '3dxInspiration').pipe(
            Effect.provide(Manifest.LiveReadManifestService),
            Effect.provideService(Manifest.ManifestConfigService, {
                manifestUrl: Effect.succeed(manifestUrl),
            }),
            Effect.provide(FetchHttpClient.layer),
        ),
    );

    return status;
};
